<template>
  <div class="folder-wrap">
    <div class="order-info-item" @click="openClientFilesModal">
      <template >
        <a
          class="folder w-inline-block"
          :class="[{'empty': !clientScans.length}]"
          tabindex="0"
        >
          <div class="icon-24px icon-24px-mr4 w-embed">
            <FolderIcon />
          </div>
          <div class="text">Файлы клиники
            <span class="text-secondary">{{clientScans.length}}</span>
          </div>
        </a>
      </template>
    </div>
    <div class="order-info-item" @click="openLabFilesModal">
      <template>
        <a
          class="folder w-inline-block"
          :class="[{'empty': !labScans.length}]"
          tabindex="0"
        >
          <div class="icon-24px icon-24px-mr4 w-embed">
            <FolderIcon />
          </div>
          <div class="text">Файлы лаборатории
            <span class="text-secondary" v-if="labScans.length">{{labScans.length}}</span>
          </div>
          <div class="hint" v-if="!labScans.length">Лаборатория загрузит файлы после выполнения заказа</div>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
  import ClientFilesModal from './ClientFilesModal';
  import FolderIcon from '@/icons/folder.svg';
  import { mapActions} from 'vuex';

  export default {
    name: 'ScansInfo',
    components: {FolderIcon},
    props: {
      labScans: {
        type: Array,
        default: () => ([]),
      },
      clientScans: {
        type: Array,
        default: () => ([]),
      },
      orderId: Number,
      tab: String,
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      openClientFilesModal () {
        if (!this.clientScans.length) return;
        this.openModal({
          component: ClientFilesModal,
          context: {
            files: this.clientScans,
            orderId: this.orderId,
            isClient: true,
            tab: this.tab,
            attributes: {
              windowClass: 'window-720',
            },
          },
        });
      },
      openLabFilesModal () {
        if (!this.labScans.length) return;
        this.openModal({
          component: ClientFilesModal,
          context: {
            files: this.labScans,
            orderId: this.orderId,
            isClient: false,
            tab: this.tab,
            attributes: {
              windowClass: 'window-720',
            },
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  a {
    outline: none;
    cursor: pointer;
  }
  .folder.empty:hover .hint{
    display: block;
    animation: hint 200ms ease-out forwards;
  }
</style>
